import { Button, Card, CardBody, Flex, Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { SavedSearchModel, SavedSearchAlertCadenceDays } from '../../../types/savedSearches'
import { defineMessages, useIntl } from 'react-intl'
import { useState } from 'react'
import { SavedSearchManageAlertsModal } from './SavedSearchManageAlertsModal'

interface SavedSearchAlertsCardProps {
  savedSearch: SavedSearchModel
}

const MSG = defineMessages({
  weeklyAlertsOn: {
    id: 'HomeSearch.savedSearches.weeklyAlertsOn',
    defaultMessage: 'Weekly alerts on'
  },
  dailyAlertsOn: {
    id: 'HomeSearch.savedSearches.dailyAlertsOn',
    defaultMessage: 'Daily alerts on'
  },
  alertsOff: {
    id: 'HomeSearch.savedSearches.alertsOff',
    defaultMessage: 'Alerts off'
  },
  manage: {
    id: 'HomeSearch.savedSearches.manage',
    defaultMessage: 'Manage'
  }
})

export const SavedSearchAlertsCard = ({ savedSearch }: SavedSearchAlertsCardProps) => {
  const intl = useIntl()
  const [isShowingManageAlertsModal, setIsShowingManageAlertsModal] = useState(false)

  const getAlertFrequencyText = () => {
    if (savedSearch?.alertCadenceDays === 1) {
      return intl.formatMessage(MSG.dailyAlertsOn)
    } else if (savedSearch?.alertCadenceDays === 7) {
      return intl.formatMessage(MSG.weeklyAlertsOn)
    } else if (savedSearch?.alertCadenceDays === null) {
      return intl.formatMessage(MSG.alertsOff)
    }
    return intl.formatMessage(MSG.alertsOff)
  }

  const AlertsIcon = ({ alertCadenceDays }: { alertCadenceDays: SavedSearchAlertCadenceDays }) => {
    const isOn = alertCadenceDays !== 0 && alertCadenceDays !== null && alertCadenceDays !== undefined
    return (
      <Flex
        backgroundColor={isOn ? 'success.300' : 'neutral.400'}
        borderRadius='50%'
        width='20px'
        height='20px'
        alignItems='center'
        justifyContent='center'
      >
        <Icon
          width='12px'
          height='12px'
          name={isOn ? 'bell-filled' : 'bell'}
          color={isOn ? 'success.700' : 'neutral.900'}
        />
      </Flex>
    )
  }
  return (
    <Card width='100%'>
      <CardBody px={4} py={2}>
        <Flex alignItems='center' justifyContent='space-between'>
          <Flex alignItems='center'>
            <AlertsIcon alertCadenceDays={savedSearch?.alertCadenceDays} />
            <Text size='sm' mb={0} ml={2}>
              {getAlertFrequencyText()}
            </Text>
          </Flex>
          <Button
            leftIcon={<Icon name='pencil' />}
            variant='ghost'
            size='xs'
            colorScheme='primary'
            onClick={() => setIsShowingManageAlertsModal(true)}
          >
            {intl.formatMessage(MSG.manage)}
          </Button>
        </Flex>
      </CardBody>
      <SavedSearchManageAlertsModal
        savedSearch={savedSearch}
        isOpen={isShowingManageAlertsModal}
        setIsOpen={setIsShowingManageAlertsModal}
      />
    </Card>
  )
}
